import { useContext, useRef } from "react";
import { useRegisterFocusable } from "../../hooks/useRegisterFocusable";
import { AppDebugSettings } from "../../contexts/DebugSettingsContext";
import { useRemoteNavigation } from "../../contexts/RemoteNavigationContext";
import { useAuth } from "../../hooks/useAuth";
import { mapPosToStyle, setDataNavValues } from "../utils";
import { NavigationData, Position } from "../../../config/interactive/types";

type props = {
	position?: Position; // Optional for non-icon interactives
	linkTo?: string;
	onClick?: Function;
	navigation: NavigationData;
	isProtected?: boolean;
	children?: React.ReactNode;
	className?: string;
};

export default function Focusable({
	position,
	onClick,
	navigation,
	linkTo,
	isProtected,
	children,
	className = "",
}: props) {
	const { isAuthenticated, platformAuth } = useAuth();
	const { showHitBox } = useContext(AppDebugSettings);
	const { handleKeyNavigation, setFocus } = useRemoteNavigation();
	const focusableRef = useRef<HTMLDivElement | null>(null);
	const id = navigation.id;

	useRegisterFocusable(navigation, focusableRef);

	const handleClick = (e: React.MouseEvent<HTMLElement>) => {
		if (isProtected && !isAuthenticated) {
			e.preventDefault();
			if (!isAuthenticated) {
				platformAuth?.redirectUserToLogin("CABN");
			} else {
				window.location.href = linkTo || "";
			}
			return;
		}
		if (onClick) onClick();
	};

	return (
		<div
			onMouseEnter={() => setFocus(id)}
			tabIndex={-1}
			onClick={handleClick}
			onKeyDown={handleKeyNavigation}
			className={`absolute outline-none ${showHitBox ? "focus:bg-red-500/50" : ""} ${className}`}
			style={position && { ...mapPosToStyle(position) }}
			{...setDataNavValues(navigation)}
			ref={focusableRef}
		>
			{children}
		</div>
	);
}
